"use client"

import { Toaster } from "react-hot-toast"
import WebsitesHeader from "../components/websites/WebsitesHeader"
import WebsitesTable from "../components/websites/WebsitesTable"
import { useMemo, useRef, useEffect } from "react"
import { useAuth } from "../context/AuthContext"
import { dictionary } from "../utils/dictionary"
import type { JSX } from "react"
import { HomePageTable } from "../components/websites/HomePageTable"
import { useNavigate, useSearchParams } from "react-router-dom"

const WebsitesPage = () => {
  const { language } = useAuth()
  const navigate = useNavigate()
  const searchParams = useSearchParams()

  const funnelsRef = useRef<JSX.Element | null>(null)
  const homesRef = useRef<JSX.Element | null>(null)

  const labels = useMemo(
    () => ({
      funnels: dictionary["funnels-label"][language],
      homes: dictionary["homes-label"][language],
    }),
    [language],
  )
  const currentType = searchParams[0].get("type") || "funnels"

  const typeSection = useMemo(() => {
    switch (currentType) {
      case "homes":
        return labels.homes
      case "funnels":
      default:
        return labels.funnels
    }
  }, [currentType, labels])

  const handleTypeSection = (type: string) => {
    const queryType = type === labels.homes ? "homes" : "funnels"

    const params = new URLSearchParams(searchParams.toString())
    params.set("type", queryType)

    navigate(`?${params.toString()}`)
  }

  if (!funnelsRef.current) {
    funnelsRef.current = <WebsitesTable />
  }

  if (!homesRef.current) {
    homesRef.current = <HomePageTable />
  }

  useEffect(() => {
    if (!searchParams[0].get("type")) {
      const params = new URLSearchParams(searchParams.toString())
      params.set("type", "funnels")
      navigate(`?${params.toString()}`)
    }
  }, [searchParams, navigate])

  return (
    <div className="min-h-screen max-w-[90%] mx-auto bg-[#F5F6FA] p-8 font-['Plus_Jakarta_Sans']">
      <Toaster position="top-right" />
      <WebsitesHeader handleTypeSection={handleTypeSection} typeSection={typeSection} />
      <div className={typeSection === labels.funnels ? "block" : "hidden"}>{funnelsRef.current}</div>
      <div className={typeSection === labels.homes ? "block" : "hidden"}>{homesRef.current}</div>
    </div>
  )
}

export default WebsitesPage
